import React, { useContext } from "react";
import { GoalFormNavigationButton } from "../../../goal_templates/common/components/generalUtilities";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";

export const ActivationModalControls = ({
  closeModal,
  hasErrors,
  action,
  actionLabel,
}) => {
  return (
    <>
      <GoalFormNavigationButton
        allow={!hasErrors}
        handleClick={action}
        title={actionLabel}
      />
      <GoalFormNavigationButton
        allow={true}
        handleClick={() => closeModal()}
        title="cancel"
      />
    </>
  );
};
